// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"ba7ea2a5","376":"f08293af","618":"c3535697"}[chunkId] + ".chunk.js";
};